import { useQuery } from "@tanstack/react-query";
import api from "./api";



const buildCountriesUrl = (region, searchStr) => {
  const params = new URLSearchParams();

  if (region && region !== "All") {
    params.append("region", region);
  }

  if (searchStr?.trim()) {
    params.append("name_like", searchStr.trim());
  }

  const query = params.toString();
  return query ? `/countries?${query}` : "/countries";
};

export const useGetCountries = (region = "All", searchStr = "") => {
  return useQuery({
    queryKey: ["countries", region, searchStr],
    queryFn: async () => {
      const url = buildCountriesUrl(region, searchStr);
      const res = await api.get(url);
      return res.data;
    },
  });
};

export const useGetCountry = (name) => {
  return useQuery({
    queryKey: ["country", name],
    enabled: !!name,
    queryFn: async () => {
      const res = await api.get(`/countries?name=${encodeURIComponent(name)}`);
      return res.data;
    },
  });
};

export const useGetCountryByAlpha3Code = (borders = []) => {
  return useQuery({
    queryKey: ["border-countries", borders],
    enabled: Array.isArray(borders) && borders.length > 0,
    queryFn: async () => {
      const requests = borders.map((code) =>
        api.get(`/countries?alpha3Code=${encodeURIComponent(code)}`),
      );

      const responses = await Promise.all(requests);

      return responses.map((res) => res.data?.[0]).filter(Boolean);
    },
  });
};
